import {API_ENDPOINTS} from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const modelConfigurationService = {
  getAllAgents: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_ALL_AGENTS,
        method: 'GET',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get all agents error:', error);
      throw error;
    }
  },

  // Create model group with agents
  createModelGroupWithAgents: async (payload) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.CREATE_MODEL_CONFIG, // should point to /api/ModelConfig/CreateModelGroupWithAgents
        method: 'POST',
        data: payload,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Create model group with agents error:', error);
      throw error;
    }
  },

  // Update model group with agents
  updateModelGroupWithAgents: async (payload) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_MODEL_CONFIG,
        method: 'POST',
        data: payload,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Update model group with agents error:', error);
      throw error;
    }
  },

  // Get agent configs by model group
  getAgentConfigsByModelGroup: async (modelGroupId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_AGENT_CONFIGS_BY_MODEL_GROUP,
        method: 'POST',
        data: { modelGroupId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get agent configs by model group error:', error);
      throw error;
    }
  },

  // Delete model group
  deleteModelGroup: async (modelGroupId, deletedBy) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_MODEL_CONFIG,
        method: 'POST',
        data: { modelGroupId, deletedBy },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete model group error:', error);
      throw error;
    }
  },

  // Get added models for a company
  getModelGroupByCompanyId: async (companyId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_ADDED_MODELS,
        method: 'POST',
        data: { companyId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    }
    catch (error) {
      console.error('Get model group by company id error:', error);
      throw error;
    }
  }
};